<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    max-width="1000"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" color="success" small> Editar</v-btn>
    </template>
    <template>
      <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-toolbar color="primary" class="title" tile elevation="0" dark
            >Editar Pessoa Alcançada</v-toolbar
          >
          <v-card-text>
            <v-row>
              <v-col cols="12" class="mb-n5">
                <v-textarea
                  v-model="formulario.nome"
                  label="Nome Completo"
                  filled
                  rows="1"
                  auto-grow
                  :rules="[(v) => !!v || 'Nome completo é obrigatório.']"
                ></v-textarea>
              </v-col>

              <v-col cols="12" class="mb-n5">
                <v-textarea
                  v-model="formulario.idade"
                  label="Idade"
                  filled
                  rows="1"
                  auto-grow
                  :rules="[(v) => !!v || 'Idade é obrigatória.']"
                ></v-textarea>
              </v-col>

              <v-col cols="12" class="mb-n8">
                <v-select
                  @change="onChangeEstado"
                  v-model="estadoTemporario"
                  :items="states"
                  item-text="nome"
                  item-value="sigla"
                  filled
                  label="Estado"
                  dense
                ></v-select>
              </v-col>

              <v-col cols="12" class="mb-n5">
                <v-select
                  @change="onChangePais"
                  v-model="paisTemporario"
                  :items="paises"
                  item-text="nome"
                  item-value="sigla"
                  filled
                  label="País"
                  dense
                ></v-select>
              </v-col>

              <v-col cols="12" class="mb-n8">
                <v-select
                  @change="onChangeGenero"
                  v-model="generoTemporario"
                  :items="generos"
                  item-text="nome"
                  item-value="genero"
                  filled
                  label="Papel"
                  dense
                  :rules="[(v) => !!v || 'Gênero é obrigatório.']"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end py-3 mx-1">
            <v-btn color="secondary" @click.prevent="fecharELimpar">Cancelar</v-btn>
            <v-btn color="primary" type="submit"> Salvar alterações </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </template>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  components: {},
  props: {
    pessoa: {
      require: false,
    },
  },
  computed: {},
  data() {
    return {
      valid: true,
      dialog: false,
      formulario: {},
      generoTemporario: this.pessoa.genero,
      estadoTemporario: this.pessoa.estado,
      paisTemporario: this.pessoa.pais,
      generos: [
        { genero: "MASCULINO", nome: "Masculino" },
        { genero: "FEMININO", nome: "Feminino" },
        { genero: "NAO_BINARIO", nome: "Não Binário" },
      ],
      states: [
        { sigla: "AC", nome: "Acre" },
        { sigla: "AL", nome: "Alagoas" },
        { sigla: "AP", nome: "Amapá" },
        { sigla: "AM", nome: "Amazonas" },
        { sigla: "BA", nome: "Bahia" },
        { sigla: "CE", nome: "Ceará" },
        { sigla: "DF", nome: "Distrito Federal" },
        { sigla: "ES", nome: "Espírito Santo" },
        { sigla: "GO", nome: "Goías" },
        { sigla: "MA", nome: "Maranhão" },
        { sigla: "MT", nome: "Mato Grosso" },
        { sigla: "MS", nome: "Mato Grosso do Sul" },
        { sigla: "MG", nome: "Minas Gerais" },
        { sigla: "PA", nome: "Pará" },
        { sigla: "PB", nome: "Paraíba" },
        { sigla: "PR", nome: "Paraná" },
        { sigla: "PE", nome: "Pernambuco" },
        { sigla: "PI", nome: "Piauí" },
        { sigla: "RJ", nome: "Rio de Janeiro" },
        { sigla: "RN", nome: "Rio Grande do Norte" },
        { sigla: "RS", nome: "Rio Grande do Sul" },
        { sigla: "RO", nome: "Rondônia" },
        { sigla: "RR", nome: "Roraíma" },
        { sigla: "SC", nome: "Santa Catarina" },
        { sigla: "SP", nome: "São Paulo" },
        { sigla: "SE", nome: "Sergipe" },
        { sigla: "TO", nome: "Tocantins" },
      ],
      paises: [
        { sigla: "AF", nome: "Afeganistão" },
        { sigla: "ZA", nome: "África do Sul" },
        { sigla: "AL", nome: "Albânia" },
        { sigla: "DE", nome: "Alemanha" },
        { sigla: "AD", nome: "Andorra" },
        { sigla: "AO", nome: "Angola" },
        { sigla: "AI", nome: "Anguilla" },
        { sigla: "AQ", nome: "Antártida" },
        { sigla: "AG", nome: "Antígua e Barbuda" },
        { sigla: "AN", nome: "Antilhas Holandesas" },
        { sigla: "SA", nome: "Arábia Saudita" },
        { sigla: "DZ", nome: "Argélia" },
        { sigla: "AR", nome: "Argentina" },
        { sigla: "AM", nome: "Armênia" },
        { sigla: "AW", nome: "Aruba" },
        { sigla: "AU", nome: "Austrália" },
        { sigla: "AT", nome: "Áustria" },
        { sigla: "AZ", nome: "Azerbaijão" },
        { sigla: "BS", nome: "Bahamas" },
        { sigla: "BH", nome: "Bahrein" },
        { sigla: "BD", nome: "Bangladesh" },
        { sigla: "BB", nome: "Barbados" },
        { sigla: "BE", nome: "Bélgica" },
        { sigla: "BZ", nome: "Belize" },
        { sigla: "BJ", nome: "Benin" },
        { sigla: "BM", nome: "Bermudas" },
        { sigla: "BY", nome: "Bielorrússia" },
        { sigla: "BO", nome: "Bolívia" },
        { sigla: "BA", nome: "Bósnia-Herzegóvina" },
        { sigla: "BW", nome: "Botsuana" },
        { sigla: "BR", nome: "Brasil" },
        { sigla: "BN", nome: "Brunei" },
        { sigla: "BG", nome: "Bulgária" },
        { sigla: "BF", nome: "Burkina Fasso" },
        { sigla: "BI", nome: "Burundi" },
        { sigla: "BT", nome: "Butão" },
        { sigla: "CV", nome: "Cabo Verde" },
        { sigla: "CM", nome: "Camarões" },
        { sigla: "KH", nome: "Camboja" },
        { sigla: "CA", nome: "Canadá" },
        { sigla: "QA", nome: "Catar" },
        { sigla: "KZ", nome: "Cazaquistão" },
        { sigla: "TD", nome: "Chade" },
        { sigla: "CL", nome: "Chile" },
        { sigla: "CN", nome: "China" },
        { sigla: "CY", nome: "Chipre" },
        { sigla: "SG", nome: "Cingapura" },
        { sigla: "CO", nome: "Colômbia" },
        { sigla: "KM", nome: "Comores" },
        { sigla: "CG", nome: "Congo" },
        { sigla: "CD", nome: "Congo, República Democrática do" },
        { sigla: "KR", nome: "Coréia do Sul" },
        { sigla: "KP", nome: "Coréia do Norte" },
        { sigla: "CI", nome: "Costa do Marfim" },
        { sigla: "CR", nome: "Costa Rica" },
        { sigla: "HR", nome: "Croácia (Hrvatska)" },
        { sigla: "CU", nome: "Cuba" },
        { sigla: "DK", nome: "Dinamarca" },
        { sigla: "DJ", nome: "Djibuti" },
        { sigla: "DM", nome: "Dominica" },
        { sigla: "EG", nome: "Egito" },
        { sigla: "SV", nome: "El Salvador" },
        { sigla: "AE", nome: "Emirados Árabes Unidos" },
        { sigla: "EC", nome: "Equador" },
        { sigla: "ER", nome: "Eritréia" },
        { sigla: "SK", nome: "Eslováquia" },
        { sigla: "SI", nome: "Eslovênia" },
        { sigla: "ES", nome: "Espanha" },
        { sigla: "US", nome: "Estados Unidos" },
        { sigla: "EE", nome: "Estônia" },
        { sigla: "ET", nome: "Etiópia" },
        { sigla: "RU", nome: "Federação Russa" },
        { sigla: "FJ", nome: "Fiji" },
        { sigla: "PH", nome: "Filipinas" },
        { sigla: "FI", nome: "Finlândia" },
        { sigla: "FR", nome: "França" },
        { sigla: "GA", nome: "Gabão" },
        { sigla: "GM", nome: "Gâmbia" },
        { sigla: "GH", nome: "Gana" },
        { sigla: "GE", nome: "Geórgia" },
        { sigla: "GI", nome: "Gibraltar" },
        { sigla: "GB", nome: "Grã-Bretanha" },
        { sigla: "GD", nome: "Granada" },
        { sigla: "GR", nome: "Grécia" },
        { sigla: "GL", nome: "Groelândia" },
        { sigla: "GP", nome: "Guadalupe" },
        { sigla: "GU", nome: "Guam (Território dos Estados Unidos)" },
        { sigla: "GT", nome: "Guatemala" },
        { sigla: "GY", nome: "Guiana" },
        { sigla: "GF", nome: "Guiana Francesa" },
        { sigla: "GN", nome: "Guiné" },
        { sigla: "GQ", nome: "Guiné Equatorial" },
        { sigla: "GW", nome: "Guiné-Bissau" },
        { sigla: "HT", nome: "Haiti" },
        { sigla: "NL", nome: "Holanda" },
        { sigla: "HN", nome: "Honduras" },
        { sigla: "HK", nome: "Hong Kong" },
        { sigla: "HU", nome: "Hungria" },
        { sigla: "YE", nome: "Iêmen" },
        { sigla: "BV", nome: "Ilha Bouvet (Território da Noruega)" },
        { sigla: "CX", nome: "Ilha Christmas" },
        { sigla: "NF", nome: "Ilha Norfolk" },
        { sigla: "KY", nome: "Ilhas Cayman" },
        { sigla: "CK", nome: "Ilhas Cook" },
        { sigla: "FO", nome: "Ilhas Faeroes" },
        { sigla: "GS", nome: "Ilhas Geórgia do Sul e Sandwich do Sul" },
        { sigla: "HM", nome: "Ilhas Heard e McDonald (Território da Austrália)" },
        { sigla: "FK", nome: "Ilhas Malvinas" },
        { sigla: "MP", nome: "Ilhas Marianas do Norte" },
        { sigla: "MH", nome: "Ilhas Marshall" },
        { sigla: "UM", nome: "Ilhas Menores dos Estados Unidos" },
        { sigla: "PN", nome: "Ilhas Pitcairn" },
        { sigla: "SB", nome: "Ilhas Salomão" },
        { sigla: "TC", nome: "Ilhas Turks e Caicos" },
        { sigla: "VI", nome: "Ilhas Virgens (Estados Unidos)" },
        { sigla: "VG", nome: "Ilhas Virgens (Inglaterra)" },
        { sigla: "WF", nome: "Ilhas Wallis e Futuna" },
        { sigla: "IN", nome: "Índia" },
        { sigla: "ID", nome: "Indonésia" },
        { sigla: "IR", nome: "Irã" },
        { sigla: "IQ", nome: "Iraque" },
        { sigla: "IE", nome: "Irlanda" },
        { sigla: "IS", nome: "Islândia" },
        { sigla: "IL", nome: "Israel" },
        { sigla: "IT", nome: "Itália" },
        { sigla: "JM", nome: "Jamaica" },
        { sigla: "JP", nome: "Japão" },
        { sigla: "JO", nome: "Jordânia" },
        { sigla: "KW", nome: "Kuait" },
        { sigla: "LA", nome: "Laos" },
        { sigla: "LS", nome: "Lesoto" },
        { sigla: "LV", nome: "Letônia" },
        { sigla: "LB", nome: "Líbano" },
        { sigla: "LR", nome: "Libéria" },
        { sigla: "LY", nome: "Líbia" },
        { sigla: "LI", nome: "Liechtenstein" },
        { sigla: "LT", nome: "Lituânia" },
        { sigla: "LU", nome: "Luxemburgo" },
        { sigla: "MO", nome: "Macau" },
        { sigla: "MK", nome: "Macedônia, Antiga República Iugoslava" },
        { sigla: "MG", nome: "Madagascar" },
        { sigla: "MY", nome: "Malásia" },
        { sigla: "MW", nome: "Malawi" },
        { sigla: "MV", nome: "Maldivas" },
        { sigla: "ML", nome: "Mali" },
        { sigla: "MT", nome: "Malta" },
        { sigla: "MA", nome: "Marrocos" },
        { sigla: "MQ", nome: "Martinica" },
        { sigla: "MU", nome: "Maurício" },
        { sigla: "MR", nome: "Mauritânia" },
        { sigla: "YT", nome: "Mayotte" },
        { sigla: "MX", nome: "México" },
        { sigla: "MM", nome: "Mianmá" },
        { sigla: "FM", nome: "Micronésia" },
        { sigla: "MZ", nome: "Moçambique" },
        { sigla: "MD", nome: "Moldova" },
        { sigla: "MC", nome: "Mônaco" },
        { sigla: "MN", nome: "Mongólia" },
        { sigla: "MS", nome: "Montserrat" },
        { sigla: "NA", nome: "Namíbia" },
        { sigla: "NR", nome: "Nauru" },
        { sigla: "NP", nome: "Nepal" },
        { sigla: "NI", nome: "Nicarágua" },
        { sigla: "NE", nome: "Níger" },
        { sigla: "NG", nome: "Nigéria" },
        { sigla: "NU", nome: "Niue" },
        { sigla: "NO", nome: "Noruega" },
        { sigla: "NC", nome: "Nova Caledônia" },
        { sigla: "NZ", nome: "Nova Zelândia" },
        { sigla: "OM", nome: "Omã" },
        { sigla: "PW", nome: "Palau" },
        { sigla: "PA", nome: "Panamá" },
        { sigla: "PG", nome: "Papua-Nova Guiné" },
        { sigla: "PK", nome: "Paquistão" },
        { sigla: "PY", nome: "Paraguai" },
        { sigla: "PE", nome: "Peru" },
        { sigla: "PF", nome: "Polinésia Francesa" },
        { sigla: "PL", nome: "Polônia" },
        { sigla: "PR", nome: "Porto Rico" },
        { sigla: "PT", nome: "Portugal" },
        { sigla: "KE", nome: "Quênia" },
        { sigla: "KG", nome: "Quirguistão" },
        { sigla: "KI", nome: "Quiribati" },
        { sigla: "SY", nome: "República Árabe da Síria" },
        { sigla: "CF", nome: "República Centro-Africana" },
        { sigla: "MM", nome: "República Democrática de Mianmá" },
        { sigla: "CZ", nome: "República Tcheca" },
        { sigla: "RE", nome: "Reunião" },
        { sigla: "RO", nome: "Romênia" },
        { sigla: "RW", nome: "Ruanda" },
        { sigla: "EH", nome: "Saara Ocidental" },
        { sigla: "PM", nome: "Saint Pierre e Miquelon" },
        { sigla: "AS", nome: "Samoa Americana" },
        { sigla: "WS", nome: "Samoa Ocidental" },
        { sigla: "SM", nome: "San Marino" },
        { sigla: "SH", nome: "Santa Helena" },
        { sigla: "LC", nome: "Santa Lúcia" },
        { sigla: "BL", nome: "São Bartolomeu" },
        { sigla: "KN", nome: "São Cristóvão e Névis" },
        { sigla: "MF", nome: "São Martim" },
        { sigla: "SX", nome: "São Martinho" },
        { sigla: "ST", nome: "São Tomé e Príncipe" },
        { sigla: "SN", nome: "Senegal" },
        { sigla: "SL", nome: "Serra Leoa" },
        { sigla: "CS", nome: "Sérvia e Montenegro (antiga)" },
        { sigla: "SC", nome: "Seychelles" },
        { sigla: "KP", nome: "Síria" },
        { sigla: "SO", nome: "Somália" },
        { sigla: "LK", nome: "Sri Lanka" },
        { sigla: "SZ", nome: "Suazilândia" },
        { sigla: "SD", nome: "Sudão" },
        { sigla: "SE", nome: "Suécia" },
        { sigla: "CH", nome: "Suíça" },
        { sigla: "SR", nome: "Suriname" },
        { sigla: "SJ", nome: "Svalbard e Jan Mayen" },
        { sigla: "TH", nome: "Tailândia" },
        { sigla: "TW", nome: "Taiwan" },
        { sigla: "TJ", nome: "Tajiquistão" },
        { sigla: "TZ", nome: "Tanzânia" },
        { sigla: "TF", nome: "Terras Austrais e Antárticas Francesas" },
        { sigla: "IO", nome: "Território Britânico do Oceano índico" },
        { sigla: "PS", nome: "Território Palestino Ocupado" },
        { sigla: "TH", nome: "Territórios do Sul da França" },
        { sigla: "TL", nome: "Timor Leste" },
        { sigla: "TG", nome: "Togo" },
        { sigla: "TK", nome: "Toquelau" },
        { sigla: "TO", nome: "Tonga" },
        { sigla: "TT", nome: "Trinidad e Tobago" },
        { sigla: "TN", nome: "Tunísia" },
        { sigla: "TM", nome: "Turcomenistão" },
        { sigla: "TR", nome: "Turquia" },
        { sigla: "TV", nome: "Tuvalu" },
        { sigla: "UA", nome: "Ucrânia" },
        { sigla: "UG", nome: "Uganda" },
        { sigla: "UY", nome: "Uruguai" },
        { sigla: "UZ", nome: "Uzbequistão" },
        { sigla: "VU", nome: "Vanuatu" },
        { sigla: "VA", nome: "Vaticano" },
        { sigla: "VE", nome: "Venezuela" },
        { sigla: "VN", nome: "Vietnã" },
        { sigla: "WF", nome: "Wallis e Futuna" },
        { sigla: "ZM", nome: "Zâmbia" },
        { sigla: "ZW", nome: "Zimbábue" },
      ],
    };
  },
  created() {
    this.formulario = { ...this.pessoa };
  },
  methods: {
    ...mapActions("pessoaAlcancada", ["editarPessoaAlcancada"]),

    onChangeEstado(value) {
      this.formulario["estado"] = value;
    },

    onChangePais(value) {
      this.formulario["pais"] = value;
    },

    onChangeGenero(value) {
      this.formulario["genero"] = value;
    },

    save() {
      if (this.$refs.form.validate()) {
        this.update()
          .then((pessoa) => {
            this.$refs.form.resetValidation();
            this.formulario = {};
            this.$emit("save", { pessoa });
            this.fecharELimpar();
          })
          .catch((error) => {
            if (error.response) {
              this.errorMessage = error.response.data;
            }
          });
      }
    },
    update() {
      let payload = {
        projetoId: parseInt(this.$route.params.projetoId),
        pessoaAlcancadaId: this.formulario.id,
        pessoaAlcancada: this.formulario,
      };

      return this.editarPessoaAlcancada(payload);
    },
    fecharELimpar() {
      this.formulario = { ...this.pessoa };
      this.dialog = false;
    },
  },
};
</script>
